import { yesNoDontKnow } from "./helpers";
import { Steps } from "./types";

export const combinationSteps: Steps = {
  q19: {
    id: "q19",
    slug: "befintlig-behandling",
    text: "Ta över befintlig behandling?",
    clarification: "",
    type: "boolean",
    nextStep: (answers) => (answers?.q19 ? "q22" : "q21"),
  },
  q20: {
    id: "q20",
    slug: "hypertonidiagnos-sambehandling-1",
    text: "Har du tidigare fått diagnosen högt blodtryck (hypertoni) av en läkare?",
    clarification:
      "Du ska ha fått diagnosen efter utredning och blivit rekommenderad behandling (t.ex. medicinering eller livsstilsbehandling).",
    type: "multipleChoice",
    options: yesNoDontKnow,
    nextStep: (answers) => (answers?.q20 === 1 ? null : "q24"),
  },
  q21: {
    id: "q21",
    slug: "hypertonidiagnos-sambehandling-2",
    text: "Har du tidigare fått diagnosen högt blodtryck (hypertoni) av en läkare?",
    clarification:
      "Du ska ha fått diagnosen efter utredning och blivit rekommenderad behandling (t.ex. medicinering eller livsstilsbehandling).",
    type: "multipleChoice",
    options: yesNoDontKnow,
    nextStep: () => "q23",
  },
  q22: {
    id: "q22",
    slug: "vilken-medicin-sambehandling",
    text: "Vilken medicin?",
    type: "multipleChoice",
    options: [
      {
        text: "Ozempic",
      },
      {
        text: "Wegovy",
      },
      {
        text: "Mysimba",
      },
      {
        text: "Orlistat",
      },
      {
        text: "Rybeisus",
      },
      {
        text: "Tirzepatid",
      },
      {
        text: "Annan",
      },
    ],
    fullWidthOptions: true,
    nextStep: () => "q20",
  },
  q23: {
    id: "q23",
    slug: "kroppsmått-sambehandling",
    text: "Ange din längd och vikt",
    clarification: "Ange ner till en decimal.",
    type: "physicalStats",
    nextStep: (answers) => {
      if (typeof answers?.q23 !== "number") {
        throw new Error("BMI should be a number");
      }

      if (answers?.q21 !== 1 && answers?.q23 > 27 && answers?.q23 < 30) {
        return "q29";
      }

      return "q30";
    },
  },
  q24: {
    id: "q24",
    slug: "över-35-sambehandling",
    text: "Är du över 35 år gammal?",
    clarification: "",
    type: "boolean",
    nextStep: (answers) => (answers?.q24 ? "q25" : "d1"),
  },
  q25: {
    id: "q25",
    slug: "mätt-högt-sambehandling",
    text: "Har du vid något tillfälle uppmätt ett högt blodtryck i samband med en undersökning?",
    clarification:
      "T.ex. en hälsoundersökning, vårdbesök, blodcentralen eller på apotek. Ett blodtrycksvärde på 140/90 eller högre räknas som ett högt blodtryck.",
    type: "boolean",
    nextStep: () => "q26",
  },
  q26: {
    id: "q26",
    slug: "diagnoser-sambehandling",
    text: "Har, eller har du haft någon av följande diagnoser?",
    clarification: [
      "Förmaksflimmer eller förmaksfladder",
      "Infektion i hjärtklaff, hjärtmuskel eller hjärtsäck",
      "Förträngning eller läckage i hjärtklaff",
      "Venös blodpropp i ben eller arm",
      "Blodpropp i lungkärlen",
      "Annan hjärt-kärlsjukdom",
    ],
    type: "boolean",
    nextStep: () => "q27",
  },
  q27: {
    id: "q27",
    slug: "diabetes-sambehandling",
    text: "Har du diabetes?",
    clarification: "OBS! Ej inräknat graviditetsdiabetes.",
    type: "boolean",
    nextStep: () => "q28",
  },
  q28: {
    id: "q28",
    slug: "ärftlighet-sambehandling",
    text: "Har du någon förälder eller syskon som behandlats för högt blodtryck innan 65 års ålder?",
    clarification: "OBS! Ej inräknat graviditetsdiabetes.",
    type: "multipleChoice",
    options: yesNoDontKnow,
    nextStep: (answers) => {
      const probabilityAnswers = [answers?.q25, answers?.q26, answers?.q27];
      const bmi = answers?.q23;

      if (bmi) {
        if (
          Number(bmi) < 30 &&
          probabilityAnswers.every((a) => !a) &&
          answers?.q28 !== 1
        ) {
          return "d4";
        }
      } else if (probabilityAnswers.every((a) => !a) && answers?.q28 !== 1) {
        return "d4";
      }

      return "q30";
    },
  },
  q29: {
    id: "q29",
    slug: "andra-riskfaktorer-sambehandling",
    text: "Andra riskfaktorer",
    clarification: "Har du andra riskfaktorer?",
    type: "boolean",
    nextStep: () => "q24",
  },
  q30: {
    id: "q30",
    slug: "har-du-en-målvikt-sambehandling",
    text: "Har du en målvikt?",
    type: "boolean",
    nextStep: (answers) => (answers?.q30 ? "q31" : null),
  },
  q31: {
    id: "q31",
    slug: "vilken-målvikt-sambehandling",
    text: "Vad är din målvikt?",
    type: "goalWeight",
    nextStep: () => null,
  },
};
